<app-webpage-analytics></app-webpage-analytics>

<div class="flex">
    <div class="ontario-row recordContainer">

        <app-breadcrumbs></app-breadcrumbs>

        <div class="divider">
            <h1> {{ 'abandoned.mine.identifier' | translate | async }}: {{ abandoned_mine_identifier }} </h1>
        </div>

        <app-copy-to-clipboard [index]="databaseIndex" [fileNumber]="abandoned_mine_identifier"></app-copy-to-clipboard>

        <ng-template [ngTemplateOutlet]="detailsTable"></ng-template>

        <div class="ontario-accordions__container">
            <div class="ontario-accordion__controls">
                <button class="ontario-accordion__button--expand-all" aria-expanded="false">
                    <span class="ontario-accordion--expand-open-all">{{ 'expand.all' | translate | async }}</span>
                    <span class="ontario-accordion--expand-close-all">{{ 'collapse.all' | translate | async }}</span>
                </button>
            </div>
            <div class="ontario-accordion" id="accordion-1">
                <button class="ontario-accordion__button" id="accordion-button-id-1" aria-controls="accordion-content-1"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'location' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-1" aria-labelledby="accordion-button-id-1" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="locationDetails"></ng-template>
                </section>
            </div>
            <div *ngIf="features" class="ontario-accordion" id="accordion-2">
                <button class="ontario-accordion__button" id="accordion-button-id-2" aria-controls="accordion-content-2"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'hazard.feature.information' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-2" aria-labelledby="accordion-button-id-2" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="hazardFeatureTable"></ng-template>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-9">
                <button class="ontario-accordion__button" id="accordion-button-id-9" aria-controls="accordion-content-9"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'report.an.error' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-9" aria-labelledby="accordion-button-id-9" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'abandoned.mine.report.an.error.text' | translate | async }}">
                            {{ 'abandoned.mine.report.an.error.text' | translate | async }}
                    </div>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-10">
                <button class="ontario-accordion__button" id="accordion-button-id-10" aria-controls="accordion-content-10"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'terms.of.use' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-10" aria-labelledby="accordion-button-id-10" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'terms.of.use.link' | translate | async }}">
                            {{ 'terms.of.use.link' | translate | async }}
                        </p>
                    </div>
                </section>
            </div>
        </div>

        <div class="mt-4 divider contactInformationContainer">
            <div class="flex mb-4 ">
                <h3 class="contactInformationTitle">
                    {{ 'contact.information' | translate | async }}
                </h3>   
                <p class="contactInformationValue" innerHTML="{{ 'abandoned.mine.contact.text' | translate | async }}">
                    {{ 'abandoned.mine.contact.text' | translate | async }}
                </p> 
            </div>
        </div>

        <ng-template #detailsTable>
            <div>
                <div>
                    <h2 class="mt-3 mb-3">{{ 'abandoned.mine.details' | translate | async }}</h2>
                </div>
                <div class="detailsContainer">
                    <div class="flex">
                        <div *ngIf="mdi_identifier_new" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'mineral.deposit.identifier' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ mdi_identifier_new | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ mdi_identifier_new | notApplicablePipe | async |highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="abandoned_mine_identifier" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'abandoned.mine.identifier' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ abandoned_mine_identifier | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ abandoned_mine_identifier | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="official_name" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'official.name' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ official_name | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ official_name | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'alternatives' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ altNames | commaSeparatedPipe:'alternate_name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ altNames | commaSeparatedPipe:'alternate_name' | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                        </div>
                        <div *ngIf="mine_site_class" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'site.classification' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ mine_site_class | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ mine_site_class | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="primary_commodity" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'primary.commodity' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ primary_commodity | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ primary_commodity | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                    </div>
    
                    <div class="flex">
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'date.mine.opened' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ date_mineopened | date: 'YYYY-MM-dd' | notApplicablePipe | async }}">
                                {{ date_mineopened | date: 'YYYY-MM-dd' | notApplicablePipe | async }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'date.mine.closed' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ date_mineclosed | date: 'YYYY-MM-dd' | notApplicablePipe | async }}">
                                {{ date_mineclosed | date: 'YYYY-MM-dd' | notApplicablePipe | async }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'mine.site.status' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ mine_site_status_code | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ mine_site_status_code | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'mine.closure.plan' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ closure_plan | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ closure_plan | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'rehabilitation.plan' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ progressive_rehab_plan | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ progressive_rehab_plan | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'mine.plans.on.file' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ mine_plan_or_section | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ mine_plan_or_section | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'legal.juristiction' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ jurisdiction | notApplicablePipe | async | highlight : this.searchTerms | highlight : this.searchTerms }}">
                                {{ jurisdiction | notApplicablePipe | async | highlight : this.searchTerms | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'date.record.last.modified' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ date_lastmodified | date: 'YYYY-MM-dd' | notApplicablePipe | async }}">
                                {{ date_lastmodified | date: 'YYYY-MM-dd' | notApplicablePipe | async }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #locationDetails>
            <div>
                <div class="locationContainer">
                    <div *ngIf="mndm_township_area_name" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'township.area' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ mndm_township_area_name | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ mndm_township_area_name | notApplicablePipe| async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="amis_district_description" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'district' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ amis_district_description | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ amis_district_description | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="nts_number" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'nts' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ nts_number | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ nts_number | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div *ngIf="operational_access" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'operation.access.description' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ operational_access | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ operational_access | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div class="flex">
                        <div class="flex mb-0">
                            <p class="font-weight--bold mr-1">{{ 'longitude' | translate | async }}:</p>
                            <p innerHTML="{{ latitude_decimal_degrees | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ latitude_decimal_degrees | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                            <p class="ml-1 mr-1">{{ '|' }}</p>
                            <p class="font-weight--bold mr-1">{{ 'latitude' | translate | async }}:</p>
                            <p innerHTML="{{ longitude_decimal_degrees | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ longitude_decimal_degrees | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex mb-0">
                            <p class="font-weight--bold mr-1">{{ 'utm.zone' | translate | async }}:</p>
                            <p innerHTML="{{ utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                            <p class="ml-1 mr-1">{{ '|' }}</p>
                            <p class="font-weight--bold mr-1">{{ 'easting' | translate | async }}:</p>
                            <p innerHTML="{{ utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                            <p class="ml-1 mr-1">{{ '|' }}</p>
                            <p class="font-weight--bold mr-1">{{ 'northing' | translate | async }}:</p>
                            <p innerHTML="{{ utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                    </div>
                    <div *ngIf="utm_datum" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'utm.datum' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ utm_datum | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ utm_datum | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                    </div>
                    <div *ngIf="point_location_description" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'point.location.description' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ point_location_description | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ point_location_description | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                    </div>
                    <div *ngIf="location_method" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'location.method' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ location_method | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ location_method | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                    </div>
                    <div *ngIf="deposit_access_description" class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'access.description' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ deposit_access_description | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ deposit_access_description | notApplicablePipe | async | highlight : this.searchTerms }}</p>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #hazardFeatureTable>
            <div>
                <div class="ontario-table-container">
                    <div class="ontario-table-div mb-0">
                        <table class="flex-child" tabindex="0">
                            <thead>
                                <tr>
                                    <th scope="col">{{ 'mine.feature' | translate | async }}</th>
                                    <th scope="col">{{ 'hazard.status' | translate | async }}</th>
                                    <th scope="col">{{ 'feature.condition' | translate | async }}</th>
                                    <th scope="col">{{ 'utm.zone' | translate | async }}</th>
                                    <th scope="col">{{ 'easting' | translate | async }}</th>
                                    <th scope="col">{{ 'northing' | translate | async }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let feature of record.features">
                                    <td scope="row"
                                        innerHTML="{{ feature.feature_type | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ feature.feature_type | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row"
                                        innerHTML="{{ feature.hazard_status | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ feature.hazard_status | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row"
                                        innerHTML="{{ feature.mine_feature_condition_desc  | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ feature.mine_feature_condition_desc | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row"
                                        innerHTML="{{ feature.utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ feature.utm_zone | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row"
                                        innerHTML="{{ feature.utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ feature.utm_easting | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                    <td scope="row"
                                        innerHTML="{{ feature.utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}">
                                        {{ feature.utm_northing | notApplicablePipe | async | highlight : this.searchTerms }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>

    <!-- Scroll Button -->
    <button onClick="scrollToTop()" class="ontario-back-to-top--default">
        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-arrow-up"></use>
        </svg>
        {{ 'top' | translate | async }}
    </button>
    
</div>